'use client';

import { useEffect, useState } from 'react';
import type { CSSProperties } from 'react';

// Las CSS vars del tema del microsite (--ms-primary, etc.) las setea `ThemeProvider` como inline
// style en `<div data-ms-theme>`. Los portales de Radix (Dialog, Popover…) montan en
// `document.body`, FUERA de ese div, así que pierden el color del evento y caen al default
// global de globals.css (`--ms-primary: #13ec5b`, verde).
//
// Este hook lee las vars YA resueltas del div del tema y las devuelve para reaplicarlas como
// `style` en el contenido del portal (p. ej. `<DialogContent style={useMicrositeThemeVars()}>`)
// — restableciendo el color del evento dentro del modal. Incluye `--ms-primary-hsl` para que el
// puente shadcn (`[style*="--ms-primary-hsl"] { --primary: … }`) también funcione dentro.
const MS_VARS = [
  '--ms-primary',
  '--ms-primary-hover',
  '--ms-on-primary',
  '--ms-primary-hsl',
  '--ms-text-base',
  '--ms-radius',
  '--ms-bg-light',
  '--ms-bg-dark',
  '--ms-on-bg-dark',
  '--ms-font-display',
] as const;

export function useMicrositeThemeVars(): CSSProperties {
  const [vars, setVars] = useState<Record<string, string>>({});
  useEffect(() => {
    const el = document.querySelector('[data-ms-theme]');
    if (!el) return;
    const cs = getComputedStyle(el);
    const next: Record<string, string> = {};
    for (const v of MS_VARS) {
      const val = cs.getPropertyValue(v).trim();
      if (val) next[v] = val;
    }
    setVars(next);
  }, []);
  return vars as CSSProperties;
}
